export class DigitalRetailing {
  private openButton: HTMLButtonElement;
  private sliderDiv: HTMLDivElement;
  private iframeElement: HTMLIFrameElement | null = null;

  private widgetData: {
    containerSelector: string;
    buttonName: string;
    iframeUrl: string;
    customClassName: string;
    module: string;
  };

  constructor(widgetData: {
    containerSelector: string;
    buttonName: string;
    iframeUrl: string;
    customClassName: string;
    module: string;
  }) {
    this.widgetData = widgetData;

    // Create the hidden iframe
    // this.iframeElement = this.createIframe();

    // Create and style the button
    this.openButton = this.createButton();
    // this.openButton.style.visibility = 'hidden'; // Initially hidden

    // Create the sliding div
    this.sliderDiv = this.createSliderDiv();

    this.handleConnectIframe();

    // Setup event listeners
    this.setupEventListeners();
  }

  // Function to find 18-character alphanumeric strings in webpage text and URL
  private findAlphanumericInPageAndURL(): void {
    const regex = /\b[A-Za-z0-9]{17}\b/g; // Regular expression for 18-character alphanumeric strings

    // 1. Search in the entire text content of the webpage
    const bodyText = document.body.innerText; // Get all visible text on the page
    const textMatches = bodyText.match(regex) || [];

    // 2. Search in the current webpage URL
    const url = window.location.href; // Get the current webpage URL
    const urlMatches = url.match(regex) || [];

    // Combine results and remove duplicates
    const allMatches = [...new Set([...textMatches, ...urlMatches])];

    // Return the results as an object
    return {
      textMatches,
      urlMatches,
      allMatches,
    };
  }

  private removeExistingIframe(): void {
    if (this.iframeElement) {
      this.iframeElement.remove();
      this.iframeElement = null;
    }
  }

  private handleConnectIframe(): void {
    this.removeExistingIframe(); // Ensure no duplicate iframes
    this.iframeElement = this.createIframe();
    this.iframeElement.style.visibility = 'hidden';

    document.body.appendChild(this.sliderDiv);
    this.sliderDiv.appendChild(this.iframeElement);
  }

  render(parentElement: HTMLElement): void {
    parentElement.appendChild(this.openButton);
  }

  private createButton_(): HTMLButtonElement {
    const button = document.createElement('button');
    button.id = 'open-slider-button';
    button.textContent = this.widgetData.buttonName;

    // Default button styles
    button.style.cssText = `
          background-color: #5e50f1;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 10px 15px;
          cursor: pointer;
          font-weight: bold;
          outline: none;
        `;

    if (this.widgetData.customClassName) {
      button.className = this.widgetData.customClassName;
    }

    button.addEventListener('click', this.openSlider.bind(this));
    return button;
  }

  private createButton(): HTMLButtonElement {
    const button = document.createElement('button');
    button.id = 'open-slider-button';
    button.textContent = this.widgetData.buttonName;

    // Apply default and custom styles
    button.style.cssText = `
        background-color: #5e50f1;
        color: white;
        border: 1px solid #5e50f1;
        border-radius: 4px;
        padding: 11px 14px;
        cursor: pointer;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-weight: 500;
        outline: none;
        visibility: hidden;
      `;

    if (this.widgetData.customClassName) {
      button.className = this.widgetData.customClassName;
    }

    button.addEventListener('click', this.openSlider.bind(this));

    return button;
  }

  private createSliderDiv(): HTMLDivElement {
    const sliderDiv = document.createElement('div');
    sliderDiv.id = 'iframe-slider';
    sliderDiv.style.cssText = `
      position: fixed;
      top: 0;
      right: -100%;
      width: 80%;
      height: 100%;
      background-color: #fff;
      box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
      transition: right 0.5s ease-in-out;
      z-index: 10000;
      display: flex;
      flex-direction: column;
    `;

    // Create the overlay div
    const overlayDiv = document.createElement('div');
    overlayDiv.id = 'bg-overlay';
    overlayDiv.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8); /* Black with 80% opacity */
      z-index: 1;
    `;

    // sliderDiv.appendChild(overlayDiv);

    // Create the overlay div
    const wrapperDiv = document.createElement('div');
    wrapperDiv.id = 'wrapper';

    // sliderDiv.appendChild(wrapperDiv);

    // Create the header div
    const headerDiv = document.createElement('div');
    headerDiv.id = 'iframe-header';
    headerDiv.style.cssText = `
      height: 80px;
      border-bottom: 1px solid #E3E3E3;
      display: flex;
      justify-content: flex-end;
      padding: 0 100px;
    `;

    // sliderDiv.appendChild(headerDiv);

    // Close button inside slider
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.style.cssText = `
      padding: 5px 10px;
      border: none;
      cursor: pointer;
      font-size: 0;
      background-color: transparent;
    `;
    closeButton.addEventListener('click', this.closeSlider.bind(this));

    // Adding SVG close icon
    closeButton.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.40994 8L15.7099 1.71C15.8982 1.5217 16.004 1.2663 16.004 1C16.004 0.733701 15.8982 0.478306 15.7099 0.290002C15.5216 0.101699 15.2662 -0.00408936 14.9999 -0.00408936C14.7336 -0.00408936 14.4782 0.101699 14.2899 0.290002L7.99994 6.59L1.70994 0.290002C1.52164 0.101699 1.26624 -0.00408912 0.999939 -0.00408912C0.733637 -0.00408912 0.478243 0.101699 0.289939 0.290002C0.101635 0.478306 -0.00415253 0.733701 -0.00415254 1C-0.00415254 1.2663 0.101635 1.5217 0.289939 1.71L6.58994 8L0.289939 14.29C0.196211 14.383 0.121816 14.4936 0.0710478 14.6154C0.0202791 14.7373 -0.00585938 14.868 -0.00585938 15C-0.00585938 15.132 0.0202791 15.2627 0.0710478 15.3846C0.121816 15.5064 0.196211 15.617 0.289939 15.71C0.382902 15.8037 0.493503 15.8781 0.615362 15.9289C0.737221 15.9797 0.867927 16.0058 0.999939 16.0058C1.13195 16.0058 1.26266 15.9797 1.38452 15.9289C1.50638 15.8781 1.61698 15.8037 1.70994 15.71L7.99994 9.41L14.2899 15.71C14.3829 15.8037 14.4935 15.8781 14.6154 15.9289C14.7372 15.9797 14.8679 16.0058 14.9999 16.0058C15.132 16.0058 15.2627 15.9797 15.3845 15.9289C15.5064 15.8781 15.617 15.8037 15.7099 15.71C15.8037 15.617 15.8781 15.5064 15.9288 15.3846C15.9796 15.2627 16.0057 15.132 16.0057 15C16.0057 14.868 15.9796 14.7373 15.9288 14.6154C15.8781 14.4936 15.8037 14.383 15.7099 14.29L9.40994 8Z" fill="#828282"/>
      </svg>
    `;

    // wrapperDiv.appendChild(closeButton);
    headerDiv.appendChild(closeButton);

    return sliderDiv;
  }

  private createIframe(): HTMLIFrameElement {
    const iframe = document.createElement('iframe');

    iframe.id = `${this.widgetData.module}-in-iframe`;
    iframe.name = `${this.widgetData.module}-in-iframe`;

    // iframe.src = `http://localhost:5173/${this.widgetData.module}/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;
    iframe.src = `https://uat-widget.apps.dabadu.ai/${this.widgetData.module}/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;

    iframe.className = 'trade-in-iframe';
    iframe.style.cssText = `
      border: none;
    `;
    return iframe;
  }

  private openSlider(): void {
    // // Call the function and store the result
    const result = this.findAlphanumericInPageAndURL();

    if (this.iframeElement) {
      const firstMatch = result?.allMatches[0] || '';
      this.iframeElement.src += `&VIN=${firstMatch}`;
      this.iframeElement.style.visibility = 'visible';
      this.iframeElement.style.width = '100%';
      this.iframeElement.style.height = '100%';
      this.iframeElement.style.flex = '1 1 auto';
    }

    // Slide in the div
    this.sliderDiv.style.right = '0';
    document.body.style.overflow = 'hidden'; // Prevent body scroll
  }

  private closeSlider(): void {
    localStorage.setItem(`TRADE_IN_MODULE-currentStep`, '0');
    localStorage.removeItem('TRADE_IN_MODULE');

    localStorage.setItem(`digital-retailing-currentStep`, '0');
    localStorage.removeItem('digital-retailing');

    this.sliderDiv.style.right = '-100%';
    document.body.style.overflow = ''; // Restore body scroll
  }

  private updateSliderStyles(): void {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 767) {
      // Mobile
      this.sliderDiv.style.width = '100%';
    } else if (screenWidth <= 1024) {
      // Tablet
      this.sliderDiv.style.width = '90%';
    } else {
      // Default for larger screens
      this.sliderDiv.style.width = '80%';
    }
  }

  private setupEventListeners(): void {
    window.addEventListener('message', (event) => {
      if (!event.data || !event.data.res) return;

      const { type, res } = event.data;

      if (res.module !== this.widgetData.module) {
        return; // Ignore messages meant for other buttons
      }

      const closeEventType = `${this.widgetData.module}-modal-close`;
      const openEventType = `${this.widgetData.module}-modal-open-btn`;

      if (type === closeEventType) {
        this.closeSlider();
      } else if (type === openEventType) {
        this.handleIframeOpen(event.data?.res);
      } else {
        console.warn('Unhandled message type:', type);
      }
    });

    // Add a resize event listener
    window.addEventListener('resize', this.updateSliderStyles.bind(this));
    // Initial call to set the slider style
    this.updateSliderStyles();
  }

  private handleIframeOpen(response: any): void {
    this.response = response;

    if (response.success) {
      const button = document.getElementById('open-slider-button') as HTMLElement;
      if (button) {
        button.style.visibility = 'visible';
        button.style.backgroundColor = response?.primaryColor || response.bgColor || '#5e50f1';
        button.textContent =
          response.buttonName ||
          (this.widgetData.module === 'credit-score' ? 'PRE-QUALIFY NOW' : 'Free Trade-In Estimate');
      }
    } else {
      const button = document.getElementById('open-slider-button') as HTMLElement;
      const slider = document.getElementById('iframe-slider') as HTMLElement;
      slider?.remove();
      if (button) {
        button.remove();
        this.removeExistingIframe();
      }
    }
  }
}
